import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function Boot41_ban_button({ btntext, to }) {
  const navigate = useNavigate();
  return (
    <div>
      <button
        className="bg-[#0060C7] text-white rounded-full px-2 py-2 cursor-pointer flex items-center gap-2 hover:opacity-90 transition"
        onClick={() => navigate(to)}
      >
        {" "}
        <span className="bg-white text-[#0047FF] w-6 h-6 flex items-center justify-center rounded-full">
          <FiArrowRight size={14} strokeWidth={3} />
        </span>
        <span className="font-montserrat font-medium text-base">{btntext}</span>
      </button>
    </div>
  );
}
